// components/promotion/BrandSlider.js - Rebuilt with reliable SliderBar
import React from 'react';
import { Building2 } from 'lucide-react';
import SliderBar from '../SliderBar';

const BrandSlider = ({
  brands = [],
  selectedBrand = 'All',
  onBrandChange,
  onToggleSearch,
  onRefresh,
  showSearch = true,
  showRefresh = false,
  isRefreshing = false,
  lastUpdated = null,
  className = '',
  'aria-label': ariaLabel = 'Brand filter',
  brandLogos = {}
}) => {
  // Custom brand items with logos
  const brandItems = brands
    .filter(brand => brand !== 'All')
    .map((brand) => (
      <button
        key={brand}
        type="button"
        onClick={() => onBrandChange?.(brand)}
        className={`flex items-center px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-1 ${
          selectedBrand === brand
            ? 'bg-purple-600 text-white shadow-md'
            : 'bg-white text-gray-700 shadow-sm hover:bg-purple-100'
        }`}
        aria-pressed={selectedBrand === brand}
      >
        {brandLogos[brand] ? (
          <img
            src={brandLogos[brand]}
            alt={`${brand} logo`}
            className="w-5 h-5 rounded-full object-cover mr-2"
            onError={(e) => {
              // Fallback to icon if image fails to load
              const icon = document.createElement('div');
              icon.innerHTML = '<Building2 size={14} className="mr-1" />';
              e.target.parentNode.replaceChild(icon, e.target);
            }}
          />
        ) : (
          <Building2 size={14} className="mr-1" />
        )}
        {brand}
      </button>
    ));

  return (
    <div role="navigation" aria-label={ariaLabel}>
      <SliderBar
        type="brand"
        items={[]} // We'll use custom children instead
        selectedItem={selectedBrand}
        onItemChange={onBrandChange}
        onToggleSearch={onToggleSearch}
        onRefresh={onRefresh}
        showSearch={showSearch}
        showRefresh={showRefresh}
        isRefreshing={isRefreshing}
        lastUpdated={lastUpdated}
        className={className}
      >
        {brandItems}
      </SliderBar>
    </div>
  );
};

export default BrandSlider;